import { useEffect } from 'react';

function ImageLightbox({ images, currentIndex, onClose, onNavigate }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onNavigate(-1);
      if (e.key === 'ArrowRight') onNavigate(1);
    };
    window.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose, onNavigate]);

  if (images.length === 0) return null;

  const index = ((currentIndex % images.length) + images.length) % images.length;
  const src = images[index];

  const navBtnStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2002,
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    border: '1px solid rgba(255,255,255,0.2)',
    background: 'rgba(0,0,0,0.45)',
    backdropFilter: 'blur(4px)',
    color: '#fff',
    fontSize: '22px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    lineHeight: 1
  };

  return (
    <div
      className="modal-overlay"
      style={{ zIndex: 2000, cursor: 'zoom-out' }}
      onClick={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          zIndex: 2002,
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          border: '1px solid rgba(255,255,255,0.15)',
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          color: '#fff',
          fontSize: '22px',
          cursor: 'pointer',
          lineHeight: 1,
          transition: 'all 0.3s ease'
        }}
        aria-label="Fechar"
      >
        ×
      </button>
      {images.length > 1 && (
        <>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onNavigate(-1); }}
            style={{ ...navBtnStyle, left: '20px' }}
            aria-label="Anterior"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onNavigate(1); }}
            style={{ ...navBtnStyle, right: '20px' }}
            aria-label="Seguinte"
          >
            ›
          </button>
        </>
      )}
      <div
        style={{
          maxWidth: '90vw',
          maxHeight: '90vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '60px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt=""
          style={{
            maxWidth: '100%',
            maxHeight: '85vh',
            objectFit: 'contain',
            borderRadius: '4px'
          }}
        />
      </div>
      {images.length > 1 && (
        <div style={{
          position: 'absolute',
          bottom: '24px',
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'rgba(255,255,255,0.75)',
          zIndex: 2002,
          fontSize: '0.85rem',
          letterSpacing: '0.1em',
          fontWeight: 300
        }}>
          {index + 1} / {images.length}
        </div>
      )}
    </div>
  );
}

export default ImageLightbox;
